const postType = {
	news: 0,
	banners: 1,
} as const

export default postType

export type WebPostType = keyof typeof postType
